import React, { useEffect, useMemo, useState } from 'react'
import Card from '../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import Disposisi from '../../../utilities/Disposisi'
import { formatDateTimeLocalDate } from '../../../utilities/Utils'
import { FaBackspace, FaBackward, FaEye, FaPaperPlane, FaPrint, FaUpload } from 'react-icons/fa'
import ModalProses from '../modals/ModalProses'
import ModalSpp from '../modals/ModalSpp'
import ModalLapEv from '../modals/ModalLapEv'
import ModalLapVerLap from '../modals/ModalLapVerLap'
import ModalCetak from '../modals/ModalCetak'
import ModalPnbp from '../modals/ModalPnbp'
import ModalViewProses from '../modals/ModalViewProses'
import ModalViewSpp from '../modals/ModalViewSpp'
import ModalProsesDraft from '../modals/ModalProsesDraft'
import ModalProsesFinal from '../modals/ModalProsesFinal'
import SweetAlert from 'react-bootstrap-sweetalert'
import ModalViewLapEv from '../modals/ModalViewLapEv'
import ModalViewLapVerLap from '../modals/ModalViewLapVerLap'
import ModalProsesRollback from '../modals/ModalProsesRollback'
import ModalLogRollback from '../modals/ModalLogRollback'
import { FaNoteSticky } from 'react-icons/fa6'


const ExpandableComponentTugas = ({ data, reloadList }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const _resDispo = await transaksiService.listPenugasanAll(data.nomorAju)
                setListDisposisi(_resDispo.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [transaksiService, data])

    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><Disposisi idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.createdAt)}</small>
                                            {
                                                (disp.idDisposisi === 9) &&
                                                <div className="d-inline-block w-100">
                                                    <small>Nomor Sertifikat : <strong><GetNomorSertifikat nomoraju={data.nomorAju} noTugas={disp.noTugas} /></strong></small>
                                                </div>
                                            }
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses datappm={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ datappm, dataPenugasan, reloadList }) => {
    // console.log(dataPenugasan)
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [dataDisposisi, setDataDisposisi] = useState({})

    const [showAddProses, setShowAddProses] = useState(false)
    const handleCloseAddProses = () => setShowAddProses(false)
    const [showAddPenugasan, setShowAddPenugasan] = useState(false);
    const handleCloseAddPenugasan = () => setShowAddPenugasan(false);
    const [showAddLapEv, setShowAddLapEv] = useState(false)
    const handleCloseAddLapEv = () => setShowAddLapEv(false)
    const [showAddLapVerLap, setShowAddLapVerLap] = useState(false)
    const handleCloseAddLapVerLap = () => setShowAddLapVerLap(false)
    // const [showAddLapOrg, setShowAddLapOrg] = useState(false)
    // const handleCloseAddLapOrg = () => setShowAddLapOrg(false)
    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)
    const [showPnbp, setShowPnbp] = useState(false)
    const handleClosePnbp = () => setShowPnbp(false)
    const [showProsesDraft, setShowProsesDraft] = useState(false)
    const handleCloseProsesDraft = () => setShowProsesDraft(false)
    const [showProsesFinal, setShowProsesFinal] = useState(false)
    const handleCloseProsesFinal = () => setShowProsesFinal(false)

    const [showViewProses, setShowViewProses] = useState(false)
    const handleCloseViewProses = () => setShowViewProses(false)
    const [showViewPenugasan, setShowViewPenugasan] = useState(false)
    const handleCloseViewPenugasan = () => setShowViewPenugasan(false)
    const [showViewLapEv, setShowViewLapEv] = useState(false)
    const handleCloseViewLapEv = () => setShowViewLapEv(false)
    const [showViewLapVerLap, setShowViewLapVerLap] = useState(false)
    const handleCloseViewLapVerLap = () => setShowViewLapVerLap(false)

    const [handleConfirmSendNsw, setHandleConfirmNsw] = useState(false)
    const handleCloseConfirmSend = () => setHandleConfirmNsw(false)
    const [sendSuccess, setSendSuccess] = useState(false)
    const [sendFailed, setSendFailed] = useState(false)
    const [responNsw, setResponNsw] = useState(null)

    const [loadingSend, setLoadingSend] = useState(false)

    const handleClickSend = async () => {
        setLoadingSend(true)
        try {
            const respSend = await transaksiService.sendSmkhpToInsw(datappm.nomorAju)

            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(respSend.data, "text/xml");
            const response = xmlDoc.getElementsByTagName("tns:setLicenseResponse")[0]?.textContent || "No response found";

            let dataStatus = {
                nomorAju: datappm.nomorAju,
                kodeStatus: '050',
                waktuStatus: new Date(),
                createdBy: localStorage.getItem('username')
            }
            await transaksiService.addPpmStatus(JSON.stringify(dataStatus))

            setResponNsw(response)
            setHandleConfirmNsw(false)
            setSendSuccess(true)
        } catch (error) {
            setResponNsw('Gagal Kirim NSW')
            setHandleConfirmNsw(false)
            setSendFailed(true)
        }
        setLoadingSend(false)
    }

    const handleCloseSendSuccess = () => {
        setSendSuccess(false)
    }

    const handleCloseSendFailed = () => {
        setSendFailed(false)
    }

    const handleShowAdd = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            setShowAddProses(true)
        } else if (dataPenugasan.idDisposisi === 2 || dataPenugasan.idDisposisi === 4 || dataPenugasan.idDisposisi === 5 || dataPenugasan.idDisposisi === 6) {
            setShowAddPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setShowAddLapEv(true)
        } else if (dataPenugasan.idDisposisi === 8) {
            setShowAddLapVerLap(true)
            // } else if (dataPenugasan.idDisposisi === 7) {
            //     setShowAddLapOrg(true)
        } else if (dataPenugasan.idDisposisi === 10) {
            setShowPnbp(true)
        } else if (dataPenugasan.idDisposisi === 9) {
            setShowProsesDraft(true)
        } else if (dataPenugasan.idDisposisi === 11) {
            setShowProsesFinal(true)
        }
    }

    const handleShowView = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            setShowViewProses(true)
        } else if (dataPenugasan.idDisposisi === 2 || dataPenugasan.idDisposisi === 5 || dataPenugasan.idDisposisi === 4) {
            setShowViewPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setShowViewLapEv(true)
        } else if (dataPenugasan.idDisposisi === 8) {
            setShowViewLapVerLap(true)
        }
    }

    const handleClickCetak = (dataPenugasan) => {
        // console.log('cetak')
        setDataDisposisi(dataPenugasan)
        setShowCetak(true)
    }

    const handleClickSendNsw = () => {
        setHandleConfirmNsw(true)
    }

    const [showRollback, setShowRollback] = useState(false)
    const [isCetakUlang, setIsCetakUlang] = useState(null)
    const handleClickRollback = (dataPenugasan, isCetakUlang) => {
        setDataDisposisi(dataPenugasan)
        setIsCetakUlang(isCetakUlang)
        setShowRollback(true)
    }
    const handleCloseRollback = () => {
        setShowRollback(false)
    }

    const [showLogRollback, setShowLogRollback] = useState(false)
    const handleCloseLogRollback = () => setShowLogRollback(false)
    const handleClickLogRollback = () => {
        setShowLogRollback(true)
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    {
                        (dataPenugasan.noTugas === null) &&
                        // (dataPenugasan.noTugas === null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Proses</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleShowAdd(dataPenugasan)}>
                                    <FaPaperPlane /> Proses
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.noTugas !== null && dataPenugasan.idDisposisi !== 9 && dataPenugasan.idDisposisi !== 10 && dataPenugasan.idDisposisi !== 11) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShowView(dataPenugasan)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {(dataPenugasan.idDisposisi !== 1 && dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning" onClick={() => handleClickCetak(dataPenugasan)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.idDisposisi === 9) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Kirim NSW</Tooltip>
                            }>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleClickSendNsw()} disabled={loadingSend}>
                                    <FaUpload /> {loadingSend && <Spinner />} Kirim ke INSW
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Rollback</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleClickLogRollback()}>
                                    <FaNoteSticky /> History Rollback Data
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.idDisposisi === 9 && datappm.status === '028') &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Kembali ke Persetujuan Pengguna Jasa</Tooltip>
                            }>
                                <Button size="sm" variant="outline-danger" onClick={() => handleClickRollback(dataPenugasan, 'T')}>
                                    <FaBackward /> Kembalikan ke Persetujuan Pengguna Jasa
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {
                        (dataPenugasan.idDisposisi === 11 && datappm.status === '100') &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak Ulang</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleClickRollback(dataPenugasan, 'Y')}>
                                    <FaBackspace /> Cetak Ulang Sertifikat
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Kembali ke Draft</Tooltip>
                            }>
                                <Button size="sm" variant="outline-danger" onClick={() => handleClickRollback(dataPenugasan, 'T')}>
                                    <FaBackward /> Kembalikan ke Draft
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Rollback</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleClickLogRollback()}>
                                    <FaNoteSticky /> History Rollback Data
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalProses showAddProses={showAddProses} handleCloseAddProses={handleCloseAddProses} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalSpp showAddPenugasan={showAddPenugasan} handleCloseAddPenugasan={handleCloseAddPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalLapEv showAddLapEv={showAddLapEv} handleCloseAddLapEv={handleCloseAddLapEv} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalLapVerLap showAddLapVerLap={showAddLapVerLap} handleCloseAddLapVerLap={handleCloseAddLapVerLap} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalCetak showCetak={showCetak} handleCloseCetak={handleCloseCetak} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalPnbp showAddPnbp={showPnbp} handleClosePnbp={handleClosePnbp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            {/* <ModalPnbpV2 showAddPnbp={showPnbp} handleClosePnbp={handleClosePnbp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} /> */}
            <ModalProsesDraft showProsesDraft={showProsesDraft} handleCloseProsesDraft={handleCloseProsesDraft} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalProsesFinal showProsesFinal={showProsesFinal} handleCloseProsesFinal={handleCloseProsesFinal} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />

            <ModalViewProses showViewProses={showViewProses} handleCloseViewProses={handleCloseViewProses} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewSpp showViewPenugasan={showViewPenugasan} handleCloseViewPenugasan={handleCloseViewPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewLapEv showViewLapEv={showViewLapEv} handleCloseViewLapEv={handleCloseViewLapEv} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewLapVerLap showViewLapVerLap={showViewLapVerLap} handleCloseViewLapVerLap={handleCloseViewLapVerLap} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalProsesRollback showRollback={showRollback} handleCloseRollback={handleCloseRollback} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} isCetakUlang={isCetakUlang}/>
            <ModalLogRollback showLogRollback={showLogRollback} handleCloseLogRollback={handleCloseLogRollback} datappm={datappm}/>
            {
                handleConfirmSendNsw &&
                <SweetAlert
                    title="Kirim SMKHP ke INSW?"
                    warning
                    showCancel
                    confirmBtnText="Proses"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSend}
                    onCancel={handleCloseConfirmSend}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"

                />
            }
            {
                sendSuccess &&
                <SweetAlert
                    title="Kirim SMKHP Berhasil"
                    success
                    onConfirm={handleCloseSendSuccess}
                    btnSize="sm"
                >{responNsw !== null ? responNsw : ''}</SweetAlert>
            }
            {
                sendFailed &&
                <SweetAlert
                    title="Kirim SMKHP Gagal"
                    danger
                    onConfirm={handleCloseSendFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const GetNomorSertifikat = ({ nomoraju, noTugas }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [dataHc, setDataHc] = useState(null)

    useEffect(() => {
        const getHcMutu = async () => {
            try {
                let jsonMutuPK = {
                    nomorAju: nomoraju,
                    noProses: noTugas
                }
                const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
                setDataHc(resHc.data)
            } catch (error) {
                setDataHc(null)
            }
        }
        getHcMutu()
    }, [transaksiService, nomoraju, noTugas])

    return (
        <>
            {
                dataHc !== null ? dataHc.noHcMutu : ''
            }
        </>
    )
}

export default ExpandableComponentTugas